<template>
  <section class="form-section">
    <div class="flex row" v-if="isShowList">
      <div class="title-page">Solicitações</div>
      <div class="div-requests col-12 row flex">
        <CardSolicitationOs
          v-for="item in contract.solicitations"
          :check="item.isFilled"
          :os-number="item.osNumber"
          :type-os="item.typeOS"
          :key="item.onject_id"
          :redo-from-drop="item.redoFromDrop"
          :title="typeOs.name_type"
          @edit="(item) => handleShowEditSolicitation()"
          @removeCard="() => deleteSchemaRequest(item.object_id)"
        />
      </div>
    </div>
   
    <MeshForm
      v-else-if="typeOs.os_type == CABEAMENTO_MESH"
      :itemOsContract="schemeSolicitation"
      :optionsWriteOffCode="optionsItens.optionsWriteOffCode"
      :optionsTypeOS="optionsItens.optionsTypeOS"
      :listWriteOffCode="optionsItens.optionsWriteOffCode"
      :listTypeOS="[]"
      :optionsTypeOSByClassification="[]"
      :optionsActionOs="optionsItens.optionsActionOs"
      :optionsStateEquipaments="[]"
      @clearSchemaRequest="() => {}"
      @saveSchemaRequest="(requestData) => saveSchemaRequest(requestData)"
      @removeEdit="() => showEditSolicitation()"
    />
    <FormOsImmediate
      v-else-if="
        typeOs.os_type == MANUTENCAO_INDOOR_GPON ||
        Number(typeOs.os_type) === MDU_MODERNIZACAO ||
        Number(typeOs.os_type) == CONTROLE_QUALIDADE
      "
      :itemOsContract="schemeSolicitation"
      :optionsWriteOffCode="optionsItens.optionsWriteOffCode"
      :optionsTypeOS="optionsItens.optionsTypeOS"
      :listWriteOffCode="optionsItens.optionsWriteOffCode"
      :listTypeOS="[]"
      :typeOs="typeOs.os_type"
      :optionsTypeOSByClassification="[]"
      :optionsActionOs="[]"
      :optionsStateEquipaments="[]"
      @clearSchemaRequest="() => {}"
      @getTypeOsClassification="
        (classificationId) => $emit('getTypeOsClassification', classificationId)
      "
      @saveSchemaRequest="(requestData) => saveSchemaRequest(requestData)"
      @removeEdit="() => showEditSolicitation()"
    />
    <SuportCOP
      v-else-if="listOfTypesByForm.includes(Number(typeOs.os_type))"
      :itemOsContract="schemeSolicitation"
      :optionsWriteOffCode="optionsItens.optionsWriteOffCode"
      :optionsTypeOS="optionsItens.optionsTypeOS"
      :listWriteOffCode="optionsItens.optionsWriteOffCode"
      :listGenerateOs="optionsItens.generateOptions"
      :listTypeOS="[]"
      :optionsTypeOSByClassification="[]"
      :optionsActionOs="optionsItens.optionsActionOs"
      :optionsStateEquipaments="optionsItens.equipamentsOS"
      :typeOs="typeOs.os_type"
      @clearSchemaRequest="() => {}"
      @saveSchemaRequest="(requestData) => saveSchemaRequest(requestData)"
      @removeEdit="() => showEditSolicitation()"
      @onTypeOsAttendance="(attendanceId) => getTypeOsGenerate(attendanceId)"
    />
    <SubscriptionServiceForm
      v-else-if="typeOs.os_type == OS_ADESAO_SERVICO"
      :itemOsContract="schemeSolicitation"
      :optionsTypeOS="optionsItens.optionsTypeOS"
      :listTypeOS="[]"
      :optionsTypeOSByClassification="optionsItens.optionsTypeOS"
      :optionsActionOs="[]"
      @clearSchemaRequest="() => {}"
      @saveSchemaRequest="(requestData) => saveSchemaRequest(requestData)"
      @removeEdit="() => showEditSolicitation()"
    />

    <FormSolicitation
      v-else
      :itemOsContract="schemeSolicitation"
      :optionsWriteOffCode="optionsItens.optionsWriteOffCode"
      :optionsTypeOS="optionsItens.optionsTypeOS"
      :listWriteOffCode="optionsItens.optionsWriteOffCode"
      :listTypeOS="[]"
      :optionsTypeOSByClassification="optionsItens.optionsTypeOS"
      :optionsActionOs="optionsItens.optionsActionOs"
      :optionsStateEquipaments="optionsItens.equipamentsOS"
      :typeAttendance="typeOs.os_type"
      @saveSchemaRequest="(requestData) => saveSchemaRequest(requestData)"
      @clearSchemaRequest="() => {}"
      @getTypeOsClassification="
        (classificationId) => $emit('getTypeOsClassification', classificationId)
      "
      @removeEdit="() => showEditSolicitation()"
    />
  </section>
</template>

<script>
import CardSolicitationOs from "@/components/cards/CardSolicitationOs.vue";
import FormOsImmediate from "@/components/generatedOsForm/formSolicitation/FormOsImmediate.vue";
import FormSolicitation from "@/components/generatedOsForm/formSolicitation/FormSolicitation.vue";
import MeshForm from "@/components/generatedOsForm/formSolicitation/MeshForm.vue";
import ReplaceRemoteControl from "@/components/generatedOsForm/formSolicitation/ReplaceRemoteControl.vue";
import SuportCOP from "@/components/generatedOsForm/formSolicitation/SuportCOP.vue";
import { onMounted, ref } from "vue";

//----UTILS
import {
  CABEAMENTO_MESH,
  CLIENTE_RACK,
  LIMPEZA_RUIDO_INDOOR,
  MANUTENCAO_INDOOR_GPON,
  MANUTENCAO_PREV_INDOOR,
  MANUTENCAO_REPARO_DROP,
  OS_MANUTENCAO,
  SUBST_CONTROLE_REMOTO,
  TROCA_CONF_EQTO_STREAMING,
  VISITA_TECNICA_2,
  CONTROLE_QUALIDADE,
} from "@/utils/constants/typeOs/generateOs";
import {
  OS_MANUTENCAO as IMEDIATAR_OS_MANUTENCAO,
  OS_ADESAO_SERVICO,
} from "@/utils/constants/typeOs/immediateOs";
import generateUUIDv4 from "@/utils/generetaUUID.js";
import SubscriptionServiceForm from "./formSolicitation/SubscriptionServiceForm.vue";
import { MDU_MODERNIZACAO } from "@/utils/constants/typeAttendance";

export default {
  name: "SolicitationList",
  props: {
    contract: Object,
    optionsItens: Object,
    typeOs: Object,
  },
  components: {
    CardSolicitationOs,
    FormSolicitation,
    MeshForm,
    ReplaceRemoteControl,
    FormOsImmediate,
    SuportCOP,
    SubscriptionServiceForm,
  },
  emits: ["disabledtabButton", "getTypeOsClassification", "getTypeOsGenerate"],

  setup(props, { emit }) { 
    let schemeSolicitation = {
      object_id: generateUUIDv4(),
      osNumber: "",
      typeOS: null,
      movimentTerminal: 0,
      movimentscheduling: 0,
      writeOffCode: null,
      action: null,
      payment: null,
      state: null,
      observation: "",
      equipamentNumberInstall: "",
      equipamentNumberUninstall: "",
      IsDecoderComum: 0,
      cardNumberInstaled: "",
      cardNumberUninstall: "",
      initialTime: "",
      conclusionTime: "",
      option1: "",
      hourOption1: "",
      option2: "",
      hourOption2: "",
      option3: "",
      hourOption3: "",
      osQuantity: 1,
      isFilled: false,
      typeOsForAttendance: "",
    };
    let isShowList = ref(true);
    const listOfActionDeliveryTerminal = ["6", "7"];

    const listOfTypesByForm = [
      OS_MANUTENCAO,
      IMEDIATAR_OS_MANUTENCAO,
      MANUTENCAO_REPARO_DROP,
      SUBST_CONTROLE_REMOTO,
      TROCA_CONF_EQTO_STREAMING,
      MANUTENCAO_PREV_INDOOR,
      CLIENTE_RACK,
      VISITA_TECNICA_2,
      LIMPEZA_RUIDO_INDOOR,
    ];

    function addNewSolicitation() {
      props.contract.solicitations.push(schemeSolicitation);
    }

    function deleteSchemaRequest(object_id) {
      let newObjectOSRequest = props.contract.solicitations.filter((obj) => {
        return obj.object_id != object_id;
      });

      props.contract.solicitations = newObjectOSRequest;
    }

    function handleShowEditSolicitation() {
      emit("disabledtabButton", false);
      isShowList.value = false;
    }

    function showEditSolicitation() {
      emit("disabledtabButton", true);
      isShowList.value = true;
    }

    //TODO: movimentTerminal Mapper
    function setInitialValuesByTypeOs() {
      console.log(props.typeOs);
      console.log(props.contract);
      console.log(props.optionsItens);
      
      if (props.typeOs.os_type) {
        schemeSolicitation.movimentTerminal = 0;
        schemeSolicitation.action = listOfActionDeliveryTerminal.includes(
          props.typeOs.os_type
        )
          ? 2
          : 1;
        schemeSolicitation.state = 1;

        emit("getTypeOsClassification", schemeSolicitation.action);
        return;
      }
    }

    function isDisabledOptionRadio() {
      switch (props.typeOs.os_type) {
        case 5:
          return true;
        case 6:
          return true;
        default:
          return false;
      }
    }

    function saveSchemaRequest(value) {
      emit("disabledtabButton", true);
      isShowList.value = true;
      schemeSolicitation.isFilled = true;
    }

    async function validateForm() {
      //TODO: CRIAR A VALIDACAO
      return true;
    }

    function getTypeOsGenerate(attendanceId) {
      emit("getTypeOsGenerate", attendanceId);
    }

    onMounted(() => {
      setInitialValuesByTypeOs();
      addNewSolicitation();
    });

    return {
      schemeSolicitation,
      isShowList,
      //-----FUNCTIONS
      addNewSolicitation,
      deleteSchemaRequest,
      handleShowEditSolicitation,
      showEditSolicitation,
      isDisabledOptionRadio,
      saveSchemaRequest,
      validateForm,
      listOfTypesByForm,
      CABEAMENTO_MESH,
      CONTROLE_QUALIDADE,
      CLIENTE_RACK,
      LIMPEZA_RUIDO_INDOOR,
      MANUTENCAO_INDOOR_GPON,
      MDU_MODERNIZACAO,
      MANUTENCAO_PREV_INDOOR,
      MANUTENCAO_REPARO_DROP,
      OS_MANUTENCAO,
      SUBST_CONTROLE_REMOTO,
      TROCA_CONF_EQTO_STREAMING,
      VISITA_TECNICA_2,
      OS_ADESAO_SERVICO,
      getTypeOsGenerate,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-section {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.title-page {
  font-size: 1rem;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: red;
  margin: 0;
}
label {
  font-weight: bold;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}
</style>